import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService {

  private _showError = false;

  private _error$: Subject<{ method: string, status: number, url?: string }> = new Subject<{
    method: string,
    status: number,
    url?: string
  }>();

  get showErrorPage() {
    return this._showError;
  }

  clean() {
    this._showError = false;
  }

  dispatchError(method: string, status: number, url?: string) {
    this.setShowError(status);
    this._error$.next({method, status, url});
  }

  listenError() {
    return this._error$.asObservable();
  }

  private setShowError(status: number) {
    switch (true) {
      case status === 500:
      case status === 502:
        this._showError = true;
        break;
      default:
        this._showError = false;
        break;
    }
  }

}
